angular.module('qkr').factory('formBuilderService', ($http, appConfig) => ({
        createTemplate(template) {
            return $http.post(appConfig.apiUrl + 'form/createTemplate', template)
                .then(response => response.data);
        },

        updateTemplate(template) {
            return $http.post(appConfig.apiUrl + 'form/updateTemplate', template)
                .then(response => response.data);
        },

        listTemplates() {
            return $http.get(appConfig.apiUrl + 'form/listTemplates', {
                withCredentials: true
            }).then((response) => response, (response) => response);
        },

        getTemplate(templateId) {
            return $http.get(appConfig.apiUrl + 'form/' + templateId + '/getTemplate', {
                withCredentials: true
            }).then((response) => response, (response) => response);
        },

        deleteTemplate(templateId) {
            const id = {
                id: templateId
            };

            return $http.post(appConfig.apiUrl + 'form/deleteTemplate', id).then((response) => response, (response) => response);
        },

        listForms() {
            return $http.get(appConfig.apiUrl + 'form/listForms', {
                withCredentials: true
            }).then((response) => response, (response) => response);
        },

        deleteForm(formId) {
            const id = {
                id: formId
            };

            return $http.post(appConfig.apiUrl + 'form/deleteForm', id).then((response) => response, (response) => response);
        },

        listSubmissions(formId) {
            return $http.get(appConfig.apiUrl + 'form/' + formId + '/listSubmissions', {
                withCredentials: true
            }).then((response) => response, (response) => response);
        }
    }));



// WEBPACK FOOTER //
// ./src/services/formBuilder.service.js